import styled from 'styled-components';

export const ModuleSimpleInfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  font-size: .8em;

  & > div {
    display: flex;
    align-items: center;
  }
`